import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/settings/recording/')({
  beforeLoad: () => {
    throw redirect({ to: '/recording' })
  },
})
